import _ from 'lodash';
import qs from 'qs';

function composeNextUrl(entityType, entity, filter = {}) {
  if (entityType === 'supplier') {
    if (entity.name === 'Flaivy Nation AB') {
      return `/articles?filter=responsibleForDelivery%3DSamlad%2520leverans`;
    }
    return `/suppliers/${entity.name}`;
  }

  if (_.includes(['article', 'brand'], entityType)) {
    return `/${entityType}s/${entity.id}`;
  }
  if ('articleSearch' === entityType) {
    return `/articles?filter=${qs.stringify({ ...filter })}`;
  }
  return `/app/${entityType}s/${entity.id}`;
}

export default composeNextUrl;
